import React, { useState, useEffect } from 'react';
import ksBridge from '@ks/ks-bridge';
import useScroll from '@utils/useScroll';
import * as services from '@services/index';
import { IOfficalAccountStatus } from '@schemas/operation';
import { formatNumber, toLogin, isInApp } from '@utils/helpers';
import { HEALTH_OFFICIAL, FOLLOW_WHITE_LIST } from '@configs/constants';
import Button from '@components/Button';
import Toast from '@components/Toast';
import styles from './index.module.scss';

interface IProps {
  isShow: boolean;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const FollowBar = ({ isShow, setIsShow }: IProps) => {
  const [isClose, setIsClose] = useState(false);
  const [isFollow, setIsFollow] = useState(false);
  const [followCount, setFollowCount] = useState(0);
  const pageTop = useScroll()[1] as number;
  const showHeight = window.innerHeight * 1.5;

  useEffect(() => {
    setTimeout(() => {
      getFollowStatus();
    }, 0);
  }, []);

  useEffect(() => {
    if (!isClose) {
      if (pageTop > showHeight) {
        setIsShow(true);
      } else {
        setIsShow(false);
      }
    }
  }, [pageTop]);

  const getFollowStatus = async () => {
    const result: IOfficalAccountStatus = await services.operation.getOfficialAccount();
    const { fansCount, followed } = result;
    setIsFollow(followed);
    setFollowCount(fansCount);
  };

  const handleFollow = () => {
    toLogin(
      () => {
        ksBridge.requestFollowUserV2({
          userId: HEALTH_OFFICIAL,
          following: true,
          activityId: FOLLOW_WHITE_LIST,
          success: (res) => {
            if (res?.result === -1) {
              Toast.show('关注失败，请升级最新版 APP');
              return;
            }
            Toast.show(`关注成功`);
            setIsShow(false);
            setIsFollow(true);
          },
          fail: () => {
            Toast.show(`关注失败`);
          }
        });
      },
      () => {
        // do nothing
      }
    );
  };

  const handleClose = () => {
    setIsClose(true);
    setIsShow(false);
  };

  return (
    <>
      {isShow && !isFollow && (
        <div className={styles['follow-bar']}>
          <i className={styles['logo']} />
          <div className={styles['info']}>
            <h3>给你健康我们是认真的</h3>
            <p>{`${formatNumber(followCount)}人已关注`}</p>
          </div>
          <Button className={styles['focus-button']} onClick={handleFollow}>
            关注
          </Button>
          <i
            role="presentation"
            className={styles['close']}
            onClick={handleClose}
          />
        </div>
      )}
    </>
  );
};

export default FollowBar;
